import { lowerCase } from 'lodash';

import { FormTypes } from '@simplifidev/shared/dist/constants/forms';

export const isPslf = (formType: any) => lowerCase(formType) === FormTypes.pslf;
export const isIdr = (formType: any) => lowerCase(formType) === FormTypes.idr;

// Plan type value emitted by the Python calc on a path's `planType` (see
// product-server `pythonPlanTypes.SAVE`); web-app gates the same field on it.
export const SAVE_PLAN_TYPE = 'SAVE';

// Client-side filters
export const UPDATED_BY_BORROWER = 'Updated by Borrower';
export const LOAN_TYPE_FSA = 'FSA';
export const LOAN_TYPE_PLAID_FEDERAL = 'plaid federal';
export const LOAN_TYPE_PLAID_PRIVATE = 'plaid private';
